import { render, staticRenderFns } from "./card-ticket-edit.vue?vue&type=template&id=471d010f&scoped=true&"
import script from "./card-ticket-edit.vue?vue&type=script&lang=js&"
export * from "./card-ticket-edit.vue?vue&type=script&lang=js&"
import style0 from "./card-ticket-edit.vue?vue&type=style&index=0&id=471d010f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471d010f",
  null
  
)

export default component.exports